import request from '@Sys~/api/request'
import { apiUrl } from '@Sys~/api/env'
import store from '@Sys~/store'

const bdcUrl = apiUrl.bdcUrl
const gateUrl = apiUrl.gateUrl

// 查询 我提交的需求
export function ajax_userdemand(status) {
    var headers = {
      'cuid': store.getters.userId,
    }
    return request({
        headers: headers,
        baseURL: bdcUrl,
        url: '/api/demand/userdemand',
        method: 'get',
        params: {
            userId: store.getters.userId,
            status: status
        },
        withCredentials: true
    })
}

// 查询提交给我的需求
export function ajax_mydemand(status) {
    var headers = {
      'cuid': store.getters.userId,
    }
    return request({
        headers: headers,
        baseURL: bdcUrl,
        url: '/api/demand/mydemand',
        method: 'get',
        params: {
            status: status
        },
        withCredentials: true
    })
}

// 获取平台所属游戏
export function ajax_game(systemType) {
    var headers = {
      'cuid': store.getters.userId,
    }
    return request({
        headers: headers,
        baseURL: bdcUrl,
        url: '/api/demand/getGame',
        method: 'get',
        params: {
            systemType: systemType
        },
        withCredentials: true
    })
}

// 获取平台所属菜单
export function ajax_menu(type, gameKey) {
    var headers = {
      'cuid': store.getters.userId,
    }
    return request({
        headers: headers,
        baseURL: bdcUrl,
        url: '/api/demand/getMenu',
        method: 'get',
        params: {
            userId: store.getters.userId,
            type: type,
            gameKey: gameKey,
        },
        withCredentials: true
    })
}

// 获取所属模块
export function ajax_codeView(data) {
    var headers = {
      'cuid': store.getters.userId,
    }
    return request({
        headers: headers,
        baseURL: gateUrl,
        url: '/api/view/codeView',
        method: 'get',
        params: data,
        withCredentials: true
    })
}

// 编辑 创建 需求
export function ajax_demand(data) {
    var headers = {
      'cuid': store.getters.userId,
    }
    return request({
        headers: headers,
        baseURL: bdcUrl,
        url: '/api/demand/merge',
        method: 'post',
        data: data,
        withCredentials: true
    })
}

// 查询需求
export function ajax_demandDetail(id) {
    var headers = {
      'cuid': store.getters.userId,
    }
    return request({
        headers: headers,
        baseURL: bdcUrl,
        url: '/api/demand/detail/' + id,
        method: 'get',
        withCredentials: true
    })
}

// 删除需求
export function ajax_demandDelete(id) {
    var headers = {
      'cuid': store.getters.userId,
    }
    return request({
        headers: headers,
        baseURL: bdcUrl,
        url: '/api/demand/delete/' + id,
        method: 'get',
        withCredentials: true
    })
}